import { Injectable } from '@angular/core';
import { ComponentBase } from '../../component-base';
import * as Components from './components';
import { MoveTextArrow } from './components/MoveTextArrow';
import { DrawTitleBlockComponent } from './components/DrawTitleBlockComponent';
import { AddPicketComponent } from './components';

@Injectable()
export class ComponentsList extends Array<ComponentBase> {

  constructor(
    drawLineComponent: Components.DrawLineComponent,
    selectComponent: Components.SelectComponent,
    moveObjectComponent: Components.MoveObjectComponent,
    drawPolyLineComponent: Components.DrawPolyLineComponent,
    movePolylineNodesComponent: Components.MovePolylineNodes,
    polyLineScaleComponent: Components.PolyLineScaleComponent,
    drawArcComponent: Components.DrawArcComponent,
    drawCircleComponent: Components.DrawCircleComponent,
    circleScaleComponent: Components.CircleScaleComponent,
    drawRectangleComponent: Components.DrawRectangleComponent,
    rectangleScaleComponent: Components.RectangleScaleComponent,
    drawAngleComponent: Components.DrawAngleComponent,
    drawDimensionsComponent: Components.DrawDimensionsComponent,
    drawTextComponent: Components.DrawTextComponent,
    editTextComponent: Components.EditTextComponent,
    deleteObjectComponent: Components.DeleteObjectComponent,
    cloneObjectComponent: Components.CloneObjectComponent,
    addPostComponent: Components.AddPostComponent,
    editDimensionsComponent: Components.EditDimensionsComponent,
    addCornerPostComponent: Components.AddCornerPostComponent,
    editPostComponent: Components.EditPostComponent,
    editPicketComponent: Components.EditPicketComponent,
    moveTextArrow: MoveTextArrow,
    drawTitleBlockComponent: DrawTitleBlockComponent,
    addPicketComponent: AddPicketComponent
  ) {
    super(
      editTextComponent,
      cloneObjectComponent,
      rectangleScaleComponent,
      circleScaleComponent,
      drawCircleComponent,
      drawArcComponent,
      moveObjectComponent,
      movePolylineNodesComponent,
      polyLineScaleComponent,
      selectComponent,
      drawLineComponent,
      drawPolyLineComponent,
      drawRectangleComponent,
      drawAngleComponent,
      drawDimensionsComponent,
      drawTextComponent,
      deleteObjectComponent,
      addPostComponent,
      editDimensionsComponent,
      addCornerPostComponent,
      moveTextArrow,
      drawTitleBlockComponent,
      addPicketComponent,
      addCornerPostComponent,
      editPostComponent,
      editPicketComponent
    );
  }
}



// WEBPACK FOOTER //
// ./src/app/services/proTools/ComponentsList.ts